import { compose } from 'recompose';
import { connect } from 'react-redux';
import InvoicesPage from '../components/InvoicesPage';

const mapStateToProps = ({ user }) => ({
    salon: user.get('salon'),
});

export default compose(connect(mapStateToProps))(InvoicesPage);
